<template >
  <div v-if="isOpen">
    <div class="filter-wrapper" @click="closeBlock"></div>

    <div class="filter-date">
      <ul>
        <li v-for="month in monthsList" :key="month.name">
          <label>
            <input type="checkbox" :value='month.value' v-model="localSelected.months" />

            {{ month.name | translate }}
          </label>
        </li>
      </ul>

      <ul>
        <li v-for="year in yearsList" :key="year">
          <label>
            <input type="checkbox" :value='year' v-model="localSelected.years" />

            {{ year }}
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'filter-by-date',
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: ['isOpen', 'filterList', 'selected', 'close'],
  data() {
    return {
      localSelected: {
        months: [],
        years: []
      },
    }
  },
  methods: {
    closeBlock() {
      this.$emit('close')
    }
  },
  watch: {
    localSelected: {
      handler(value) {
        console.log('local selected')

        this.$emit('change', value)
      },

      deep: true,
    }
  },
  computed: {
    // renderedList() {
    //   return this.filterList.filter(i => i.name.toLowerCase().includes(this.searchInputValue.toLowerCase()))
    // },

    monthsList() {
      return [
        { value: '01', name: 'January' },
        { value: '02', name: 'February' },
        { value: '03', name: 'March' },
        { value: '04', name: 'April' },
        { value: '05', name: 'May' },
        { value: '06', name: 'June' },
        { value: '07', name: 'July' },
        { value: '08', name: 'August' },
        { value: '09', name: 'September' },
        { value: '10', name: 'October' },
        { value: '11', name: 'November' },
        { value: '12', name: 'December' },
      ]
    },

    yearsList() {
      const yearList = []

      for (let year = 2017; year <= new Date().getFullYear(); year++) {
        yearList.push(year)
      }

      return yearList
    }
  }
}
</script>

<style lang="scss">
.filter-wrapper {
  position: fixed;

  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  z-index: 4;
}

.filter-date {
  display: flex;
  position: absolute;

  top: 40px;
  left: 0;

  padding: 10px;

  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);

  background-color: #fff;

  z-index: 5;

  justify-content: space-evenly;

  width: 200px;

  // height: 400px;

  & ul {
    padding: 5px;

    margin: 10px 0;

    // height: 400px;



    overflow: auto;
  }

  & li {
    list-style-type: none;

    // 

    color: #150722;
  }
}

// .search-input-wrapper {
//   position: relative;

//   .search-input-logo {
//     position: absolute;

//     top: 5px;
//     left: 10px;
//   }

//   .search-input {
//     width: 300px;
//     padding: 5px 5px 5px 40px;
//     align-items: center;

//     border-radius: 8px;
//     border: 1px solid #B7AFBF;
//   }
// }
</style>